import Icon from '@ant-design/icons';
import React from 'react';

const OrderPendingCancellationSvg = (props: React.HTMLAttributes<SVGElement>) => (
  <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.3333 14.6667C13.6533 14.6667 10.6667 17.6533 10.6667 21.3333C10.6667 25.0133 13.6533 28 17.3333 28C21.0133 28 24 25.0133 24 21.3333C24 17.6533 21.0133 14.6667 17.3333 14.6667ZM19.5333 24.4667L16.6667 21.6V17.3333H18V21.0533L20.4667 23.52L19.5333 24.4667ZM18.6667 2.66667H14.4267C13.8667 1.12 12.4 0 10.6667 0C8.93333 0 7.46667 1.12 6.90667 2.66667H2.66667C1.2 2.66667 0 3.86667 0 5.33333V25.3333C0 26.8 1.2 28 2.66667 28H10.8133C10.0245 27.2343 9.38277 26.3305 8.92 25.3333H2.66667V5.33333H5.33333V9.33333H16V5.33333H18.6667V12.1067C19.6133 12.24 20.5067 12.52 21.3333 12.9067V5.33333C21.3333 3.86667 20.1333 2.66667 18.6667 2.66667ZM10.6667 5.33333C9.93333 5.33333 9.33333 4.73333 9.33333 4C9.33333 3.26667 9.93333 2.66667 10.6667 2.66667C11.4 2.66667 12 3.26667 12 4C12 4.73333 11.4 5.33333 10.6667 5.33333Z"
      fill="#202426"
    />
  </svg>
);

export const OrderPendingCancellationIcon = ({ className, ...props }: React.ComponentProps<typeof Icon>) => (
  <Icon component={() => <OrderPendingCancellationSvg className={className} />} {...props} />
);
